// extracted by mini-css-extract-plugin
export var closed = "_g1-1";
export var resizer = "_g1-0";